import React, {useEffect, useState} from 'react';
import {Redirect} from 'react-router-dom';
import {invoiceSignupPrefillUrlFromReturnUrl} from '../utility/invoiceSignup';

const InvoiceAccountGate = ({requestedPath}) => {
  const [destination, setDestination] = useState('');

  useEffect(() => {
    const prefillUrl = invoiceSignupPrefillUrlFromReturnUrl(requestedPath);
    if (!prefillUrl) {
      setDestination('/login');
      return undefined;
    }

    let cancelled = false;
    const resolveDestination = async () => {
      try {
        const response = await fetch(prefillUrl);
        const payload = response.ok ? await response.json() : null;
        if (!cancelled) {
          setDestination(
            payload?.success && payload?.requiresAccountCreation ? '/sign-up' : '/login'
          );
        }
      } catch (error) {
        if (!cancelled) {
          setDestination('/login');
        }
      }
    };

    resolveDestination();

    return () => {
      cancelled = true;
    };
  }, [requestedPath]);

  if (!destination) {
    return (
      <div className="d-flex justify-content-center p-5" role="status" aria-live="polite">
        Checking your CoachFirst account…
      </div>
    );
  }

  return (
    <Redirect
      to={{
        pathname: destination,
        search: `?returnUrl=${encodeURIComponent(requestedPath)}`,
        state: {from: requestedPath},
      }}
    />
  );
};

export default InvoiceAccountGate;
